import { render, staticRenderFns } from "./CustomPropertyDetails.vue?vue&type=template&id=5529a9dc&scoped=true"
import script from "./CustomPropertyDetails.vue?vue&type=script&lang=js"
export * from "./CustomPropertyDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomPropertyDetails.vue?vue&type=style&index=0&id=5529a9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529a9dc",
  null
  
)

export default component.exports